export enum ToastType {
  Success = 'success',
  Error = 'error',
}
